<template>
  <div>
    <div style="position: relative;">
      <div class="select-content">
        <!-- :placeholder="$t('_components.placeholder.select')" -->
        <v-select
          v-model="aera"
          :placeholder="'请选择范围'"
          label="label"
          value="value"
          :options="dictOptionsDic"
        />
      </div>
      <div
        id="map__container"
        style="100%;height: 300px;"
        tabindex="0"
      />
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import elementComponentVue from '../elementComponent.vue'

export default {
  components: {
    vSelect,
  },
  props: {
    coordinate: {
      type: String,
      default: '',
    },
    showMap: {
      type: [Boolean, Number],
      default: false,
    },
    params: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      map: '',
      marker: null,
      circle: null,
      value: '100',
      aera: {},
      defaultZoom: 15,
    }
  },
  computed: {
    dictOptionsDic() {
      const options = [
        {
          label: '50m',
          value: '50',
        },
        {
          label: '100m',
          value: '100',
        },
        {
          label: '200m',
          value: '200',
        },
      ]
      return options
    },
  },
  watch: {
    showMap: {
      handler() {
        if (this.showMap) {
          this.$nextTick(() => {
            // 回填坐标，绘制点位
            if (this.params.coordinate) {
              const { coordinate } = this.params
              const latlng = new window.google.maps.LatLng(coordinate.split(',')[0], coordinate.split(',')[1]);
              this.init(latlng)
              this.addMarker(latlng)

              // 回填坐标和半径，绘制点位范围
              const aera = this.params.aera || 100
              this.aera = this.dictOptionsDic.find(o => Number(o.value) === Number(aera))
              this.drawCircle(latlng)
            } else {
              this.init()
            }
          })
        }
      },
      immediate: true,
    },
    aera: {
      handler(e) {
        if (this.circle) {
          const aera = Number(this.aera.value)
          this.circle.setRadius(aera)
        }
        this.$emit('changeAera', e.value)
      },
      deep: true,
      immediate: true,
    },
    value: {
      handler(e) {
        this.initData(e)
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    initData(e) {
      const item = this.dictOptionsDic.find(el => el.value === e)
      this.aera = item
    },
    addMarker(location) {
      this.clearOverlay(this.marker);
      this.marker = new window.google.maps.Marker({
        position: location,
        map: this.map,
      });
    },
    clearOverlay(overlay) {
      if (overlay) {
        overlay.setMap(null);
      }
    },
    drawCircle(location) {
      this.clearOverlay(this.circle);
      const aera = Number(this.aera.value || 100)
      const populationOptions = {
        strokeColor: '#FF0000',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#FF0000',
        fillOpacity: 0.35,
        map: this.map,
        center: location,
        radius: aera,
      };
      this.circle = new window.google.maps.Circle(populationOptions);
      // this.map.addOverlay(circle)
    },
    init(center = null) {
      const latlng = new window.google.maps.LatLng('1.3695610016146895', '103.84262753550513');
      this.map = new window.google.maps.Map(document.getElementById('map__container'), {
        center: center || latlng,
        zoom: this.defaultZoom,
      });
      this.addClickHandle()
    },
    addClickHandle() {
      window.google.maps.event.addListener(this.map, 'click', event => {
        if (event) {
          this.addMarker(event.latLng)
          this.drawCircle(event.latLng)
          const coordinate = `${event.latLng.lat()},${event.latLng.lng()}`
          this.$emit('changePoint', coordinate)
        }
      });
    },
  },

}
</script>

<style lang="scss" scoped>
.select-content{
  width:200px;
  height: 40px;
  background: #fff;
  position: absolute;
  z-index: 100;
  left: 50%;
  transform: translateX(-50%);
  top: 10px;
}

</style>
